<template>
  <v-skeleton-loader
    color="transparent"
    type="list-item-avatar-two-line"
  />
</template>
